const mapPlacePredictionToSuggestion = (options)=>options.map(({ locality , sublocality , id  })=>({
            id,
            title: locality,
            subTitle: sublocality
        })
    )
;

export { mapPlacePredictionToSuggestion };
//# sourceMappingURL=map-place-prediction-to-suggestion.js.map
